import React from 'react'
import { createRoot } from 'react-dom/client'
import '../index.css'
import App from '../components/App'

/* global Office, document */

const INITIALIZATION_TIMEOUT = 30000 // 30 seconds

function renderError(message: string) {
  const indicator = document.getElementById('loading-indicator')
  if (indicator) {
    indicator.style.display = 'flex'
    indicator.style.flexDirection = 'column'
    indicator.style.alignItems = 'center'
    indicator.style.justifyContent = 'center'
    indicator.innerHTML = `
      <div style="text-align:center;padding:20px;font-family:Inter,system-ui,sans-serif">
        <span style="font-size:13px;color:#C1121C;display:block;margin-bottom:12px">${message}</span>
        <button id="retry-init" style="padding:8px 16px;background:#003591;color:white;border:none;border-radius:4px;cursor:pointer;font-size:13px">
          Retry
        </button>
      </div>
    `
    const retryButton = document.getElementById('retry-init')
    if (retryButton) {
      retryButton.onclick = () => globalThis.location.reload()
    }
  }
}

let isInitialized = false

const timeoutId = setTimeout(() => {
  if (!isInitialized) {
    console.error('Office.js initialization timed out.')
    renderError('Add-in initialization timed out. Please check your connection.')
  }
}, INITIALIZATION_TIMEOUT)

Office.onReady((info) => {
  isInitialized = true
  clearTimeout(timeoutId)

  if (info.host === Office.HostType.Outlook || import.meta.env.DEV) {
    const container = document.getElementById('root')
    if (container) {
      const root = createRoot(container)
      root.render(<App />)
    }
  } else {
    renderError('Unable to load add-in. Please close and try again.')
  }
})
